import { TextField, type TextFieldProps } from "@mui/material"
import type { ReactElement } from "react"
import { forwardRef } from "react"
import type { NumberFormatValues, NumericFormatProps } from "react-number-format"
import { NumericFormat } from "react-number-format"

export interface AerosNumericFieldProps
  extends Omit<TextFieldProps, "onChange" | "value" | "defaultValue" | "type">,
    Pick<
      NumericFormatProps,
      | "decimalScale"
      | "fixedDecimalScale"
      | "allowNegative"
      | "allowLeadingZeros"
      | "thousandSeparator"
      | "decimalSeparator"
      | "prefix"
      | "suffix"
    > {
  value: number | null | undefined
  onChange?: (value: number | null) => void
}

export const AerosNumericField = forwardRef<HTMLDivElement, AerosNumericFieldProps>(
  (
    {
      value,
      onChange,
      decimalScale,
      fixedDecimalScale,
      allowNegative = true,
      allowLeadingZeros = false,
      thousandSeparator = false,
      decimalSeparator = ".",
      prefix,
      suffix,
      ...textFieldProps
    },
    ref
  ): ReactElement => {
    const handleValueChange = (values: NumberFormatValues) => {
      const { floatValue } = values
      onChange?.(floatValue ?? null)
    }

    return (
      <NumericFormat
        {...textFieldProps}
        getInputRef={ref}
        value={value ?? ""}
        customInput={TextField}
        variant='outlined'
        fullWidth
        decimalScale={decimalScale}
        fixedDecimalScale={fixedDecimalScale}
        allowNegative={allowNegative}
        allowLeadingZeros={allowLeadingZeros}
        thousandSeparator={thousandSeparator}
        decimalSeparator={decimalSeparator}
        prefix={prefix}
        suffix={suffix}
        onValueChange={handleValueChange}
      />
    )
  }
)
